import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';
import api from 'lib/api';
import { Icon, translate, Button } from '@haldor/ui';
import Modal from 'containers/Modals/Modal';
import AddLinkForm from './AddLinkForm';
import placeholderImage from './default_img_links.svg';

var Prompt = /*#__PURE__*/function (_Component) {
  _inherits(Prompt, _Component);

  var _super = _createSuper(Prompt);

  function Prompt(props) {
    var _this;

    _classCallCheck(this, Prompt);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      _this.setState({
        modal: !_this.state.modal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleEdit", function (link) {
      if (link != null && link.url != null) {
        _this.setState({
          activeLink: link
        });
      } else {
        _this.setState({
          activeLink: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addhttp", function (url) {
      if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
        url = "http://" + url;
      }

      return url;
    });

    _defineProperty(_assertThisInitialized(_this), "addLink", function (event) {
      if (event != null) {
        event.preventDefault();
      }

      _this.setState({
        modal: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFormSubmit", function (values) {
      return new Promise(function (resolve) {
        api.get("OpenGraph?Url=".concat(values.url)).then(function (response) {
          var status = response.status,
              data = response.data;

          if (data != null && data.image != null) {
            values.image = data.image;
          }

          if (data != null && data.metadata != null) {
            if (data.metadata['og:description'] != null && data.metadata['og:description'].length > 0) {
              values.description = data.metadata['og:description'][0].value;

              if (values.description.length > 181) {
                values.description = values.description.slice(0, 180) + '…';
              }
            }
          }

          if (values.title == null) {
            if (data != null && data.title != null) {
              values.title = data.title;
            } else {
              values.title = '';
            }
          }

          if (values.description == null) {
            values.description = '';
          }

          if (values.image == null) {
            values.image = '';
          }

          if (_this.props.onSubmit != null) {
            _this.props.onSubmit(values);
          }

          if (_this.state.activeLink != null) {
            _this.toggleEdit();
          } else {
            _this.toggleModal();
          }

          resolve(1);
        });
      });
    });

    _this.state = {
      activeLink: null,
      modal: false
    };

    if (_this.props.openPicker != null) {
      _this.props.openPicker(_this.toggleModal);
    }

    return _this;
  }

  _createClass(Prompt, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        type: "small editor-block-modal",
        isOpen: this.state.modal,
        onClose: this.toggleModal,
        title: this.props.translate('Add link')
      }, /*#__PURE__*/React.createElement(AddLinkForm, {
        onSubmit: this.onFormSubmit,
        onCancel: this.toggleModal
      })), /*#__PURE__*/React.createElement(Modal, {
        type: "small editor-block-modal",
        isOpen: this.state.activeLink != null,
        onClose: this.toggleEdit,
        title: this.props.translate('Edit link')
      }, /*#__PURE__*/React.createElement(AddLinkForm, {
        onSubmit: this.onFormSubmit,
        onCancel: this.toggleEdit,
        initialValues: this.state.activeLink
      })), this.props.links != null ? /*#__PURE__*/React.createElement("div", {
        className: "link-resource-list"
      }, this.props.links.map(function (resource, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "link-resource-container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "link-resource"
        }, /*#__PURE__*/React.createElement("div", {
          className: "link-content"
        }, resource.image != '' ? /*#__PURE__*/React.createElement("div", {
          className: "image",
          style: {
            backgroundImage: "url(".concat(resource.image, ")")
          }
        }) : /*#__PURE__*/React.createElement("div", {
          className: "image placeholder",
          style: {
            backgroundImage: "url(".concat(placeholderImage, ")")
          }
        }), /*#__PURE__*/React.createElement("div", {
          className: "content"
        }, /*#__PURE__*/React.createElement("div", {
          className: "title",
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(resource.title)
          }
        }), /*#__PURE__*/React.createElement("div", {
          className: "description",
          dangerouslySetInnerHTML: {
            __html: DOMPurify.sanitize(resource.description)
          }
        }))), /*#__PURE__*/React.createElement("div", {
          className: "link-footer"
        }, /*#__PURE__*/React.createElement("div", {
          className: "url"
        }, /*#__PURE__*/React.createElement("a", {
          href: _this2.addhttp(resource.url),
          target: "_blank"
        }, resource.url, /*#__PURE__*/React.createElement(Icon, {
          name: "External"
        }))), /*#__PURE__*/React.createElement("span", {
          className: "delete-resource",
          onClick: function onClick() {
            return _this2.props.block.removeResource(resource);
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Bin"
        })), /*#__PURE__*/React.createElement("span", {
          className: "delete-resource",
          onClick: function onClick() {
            return _this2.toggleEdit(resource);
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Pen_Small"
        })))));
      })) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.75rem'
        }
      }), /*#__PURE__*/React.createElement(Button, {
        onClick: this.addLink
      }, this.props.translate('Add link')));
    }
  }]);

  return Prompt;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(Prompt);